import './App.css';
import {Routes, Route, Link} from 'react-router-dom';
import {useState} from 'react';
import logo from "./newlogo.png";
import React from "react";
import {PortionConversion} from "./PortionConversions";
import {WebFoodSearch} from "./WebFoodSearch";
import {WebFoodEntry} from "./WebFoodEntry";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faWeightScale,
    faSearch,
    faPlus,
    faList,
    faHome,
    faBars,
    faCalculator,
    faPlusCircle, faContactCard
} from "@fortawesome/free-solid-svg-icons";
import {WebRecipeList} from "./WebRecipeList";
import {WebRecipeEntry} from "./WebRecipeEntry";
import {LoginPage} from "./LoginPage";
import {NutrientView} from "./NutrientView";
import Cookies from 'js-cookie';
import {MultiIngredientEditor} from "./edit/MultiIngredientEditor";
import {BreadCalculator} from "./doughCalc/breadCalculator";
import ContactForm from "./contact/ContactForm";

// Retrieve values from localStorage, fall back to defaults if not set
let globalRole = localStorage.getItem('globalRole') || "GUEST";
let globalUser = localStorage.getItem('globalUser') || "Guest";
let currentCsrfTok = "";

// Helper to set and persist the role
function setGlobalRole(role: string) {
    globalRole = role;
    localStorage.setItem('globalRole', role);
}

// Helper to set and persist the user
function setGlobalUser(user: string) {
    globalUser = user;
    localStorage.setItem('globalUser', user);
}

let globalCsrfToken = "";

/**
 * get the current CSRF token
 * @returns {Promise<string>} a promise that provides the token
 */
export async function getCsrfToken(): Promise<string> {
    if (!globalCsrfToken || globalCsrfToken.length === 0) {
        let authSts = fetch(
            "/api/v1/auth/authStatus", {
                method: "GET",
                headers: {"Content-Type": "application/json", "Accept": "application/json"},
            });
        const response = await authSts;
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        globalCsrfToken = response.headers.get('X-XSRF-TOKEN') ?? "";
        return globalCsrfToken;

    }
    return Promise.resolve(globalCsrfToken);
}

/**
 * @returns {boolean} true if admin
 */
export function isAdmin(): boolean {
    return globalRole === "ADMIN";
}

/**
 * @returns {boolean} true if logged in
 */
export function isLoggedIn(): boolean {
    return globalRole !== "GUEST";
}

/**
 * @returns {boolean} true if user is a guest
 */
export function isGuest(): boolean {
    return globalRole === "GUEST";
}

/**
 * Set the user and role after a login
 * @param user {string}
 * @param role {string}
 */
export function setUserInfo(user: string, role: string): void {
    setGlobalUser(user);
    setGlobalRole(role);
}

/**
 * @returns {string} the user name
 */
export function getUserName(): string {
    return globalUser ?? "Guest";
}

function Home() {
    const [message, setMessage] = useState("");

    function logout(e: React.MouseEvent) {
        getCsrfToken().then(token => {
            fetch('/api/v1/auth/logout', {
                method: 'POST',
                headers: {"Content-Type": "application/json", "Accept": "application/json", "X-XSRF-TOKEN": token},
            }).then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.text();
            }).then(role => {
                setUserInfo("Guest", "GUEST");
                setMessage("You have been logged out.");
            })
        });
        e.preventDefault();
    }

    return <div>
        <h1>NutriCherry Recipe &amp; Conversion App</h1>
        {message?.length > 0 ? <p style={{color: 'red'}}>{message}</p> : ""}
        <div className="foodCardContainer">
            <div className="foodCard">
                <h2>Calculation and Conversion</h2>
                <ul>
                    <li><Link to="/conversions">Calculation and conversions</Link></li>
                    <li><Link to="/breadCalculator">Bread Calculator</Link></li>
                </ul>
            </div>
            <div className="foodCard">
                <h2>Food Database</h2>
                <ul>
                <li><Link to="/foodSearch">Food Database Search</Link></li>
                {isAdmin() ? <li><Link to="/foodEntry?id=0&mode=edit">&nbsp;New Food Entry</Link></li> : ""}
                {isAdmin() ? <li><Link to="/combinedFood">&nbsp;New Combined Food</Link></li> : ""}
                </ul>
            </div>
            <div className="foodCard">
                <h2>Account</h2>
                {isGuest() ? <span>Welcome guest! <Link to="/login">Login (administrators only)</Link></span> :
                    <p>You're logged in as {globalUser} <a href='#' onClick={e => logout(e)}>Logout</a></p>}
                {isLoggedIn() ? <p>Your role is {globalRole}</p> : ""}
            </div>
        </div>
    </div>
}

function App() {
    const [cookieAgreement, setCookieAgreement] = useState(Cookies.get('appUseTerms') === 'YES');
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleCookieAccept = () => {
        Cookies.set('appUseTerms', 'YES');
        setCookieAgreement(true);
    };

    let menuOpenContent = <div className="nav-links">
        <ul>
            <li><Link to="/"><FontAwesomeIcon icon={faHome}/>&nbsp;Home</Link></li>
            <li><Link to="/conversions"><FontAwesomeIcon icon={faWeightScale}/>&nbsp;Conversions</Link>
            </li>
            <li><Link to="/foodSearch"><FontAwesomeIcon icon={faSearch}/>&nbsp;Food Search</Link></li>
            <li><Link to="/breadCalculator"><FontAwesomeIcon icon={faCalculator}/>&nbsp;Bread Making Calculator</Link></li>
            <li><Link to="/contact"><FontAwesomeIcon icon={faContactCard}/>&nbsp;Contact us</Link></li>
            <li>{isAdmin() ? <Link to="/foodEntry?id=0&mode=edit"><FontAwesomeIcon icon={faPlus}/>&nbsp;Add Food</Link> : ""}</li>
            <li>{isAdmin() ? <Link to="/combinedFood?id=0&mode=edit"><FontAwesomeIcon icon={faPlusCircle}/>&nbsp;Add Combined Food</Link> : ""}</li>
            <li>{isAdmin() ? <Link to="/recipeList"><FontAwesomeIcon icon={faList}/>&nbsp;Recipe List</Link> : ""}</li>
        </ul>
    </div>;

    return (
        <div>
            <header className="App-header container">
                <div className="App-topnav">
                    <button className="hamburger-menu" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        <FontAwesomeIcon icon={faBars}/>
                    </button>
                    <a href="https://www.nutricherry.com" style={{height:"45px !important", textDecoration: 'none', fontWeight: 'bold', fontSize:"80%"}}>
                        <img src={logo} className="App-logo" alt="logo"/>
                        <span style={{position: "relative", right:"100px"}}>beta app</span>
                    </a>
                    <div className="nav-menu">
                        {isMenuOpen ? menuOpenContent : "" }
                    </div>
                </div>
            </header>
            <div className="App-content container">
                {!cookieAgreement ?
                    <div className="cookie-consent"
                         style={{
                             padding: '20px',
                             backgroundColor: '#f8f9fa',
                             marginBottom: '20px',
                             border: '2px solid #dee2e6',
                             borderRadius: '8px'
                         }}>
                        <p>In addition to the regular <a href="https://www.nutricherry.com/legal/privacy">cookie policy
                            and site
                            terms and conditions</a>, the NutriCherry web application also has another policy
                            controlling its
                            fair use.
                        </p>
                        <p>During the BETA testing phase of our website, we are temporarily providing everyone with free
                            access
                            to this app. You can use this application for your own purposes, reporting any issues you
                            find to us
                            so that we can attempt to correct them. Given it is BETA, you should not presently rely on
                            this application for
                            any exact nutritional purposes.
                        </p>
                        <p>In a subsequent update we may start to charge or require registration for some of the
                            features within the app.
                        </p>
                        <p>Fair use is defined as using this application for non-commercial purposes, such as for
                            personal or
                            educational purposes. It also means that you will not attempt to use the API directly, or
                            use this
                            service to make any automated requests. If any such usages are detected, we will take
                            appropriate
                            action, including blocking access to the application.
                        </p>
                        <button onClick={handleCookieAccept}>Accept these terms</button>
                        &nbsp;
                        <a href="https://www.nutricherry.com/">Don't use the application (NutriCherry home page)</a>
                    </div> :
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="conversions" element={<PortionConversion/>}/>
                        <Route path="foodSearch" element={<WebFoodSearch/>}/>
                        <Route path="combinedFood" element={<MultiIngredientEditor/>}/>
                        <Route path="breadCalculator" element={<BreadCalculator/>}/>
                        <Route path="foodEntry" element={<WebFoodEntry/>}/>
                        <Route path="foodView" element={<NutrientView/>}/>
                        <Route path="recipeList" element={<WebRecipeList/>}/>
                        <Route path="rcpRecipe" element={<WebRecipeEntry/>}/>
                        <Route path="login" element={<LoginPage/>}/>
                        <Route path="contact" element={<ContactForm/>}/>
                    </Routes>}
            </div>
        </div>
    );
}

export default App;